<template lang="html">
  <div class="centerx w-full flex space-x-4">
	<div class="flex-1">
    <input id='fileinputtkeyword' type='file' accept='.csv' @change="readCSV($event, keywordChipsFull)" style="display: none;" />
    <!-- <vs-button @click="popupActivo4=true" color="danger" type="border">Open fullscreen popup</vs-button> -->
	<!-- :title="'Éditer les top keywords'" -->

      <div class="w-full">
        <div class="mt-4 w-full flex  justify-between">
			<div class="flex space-x-5">
          <vs-input class="inputx" placeholder="Nouveau keyword..." v-model="newKeyword" @keyup.enter="addKeyword" ref="addKeywordsRef"/>
		  <vs-button @click="addKeyword">Ajouter</vs-button>
		</div>
     
          <div class="vx-col">
			<vx-tooltip text='Importe la colonne "top_keyword" du fichier CSV'>
			<vs-button @click="csvImport">Importer CSV</vs-button>
			</vx-tooltip>
			</div>
          
        </div>
		<vs-alert active="true" color="warning" class="mt-3">
				Plus vous saisissez de mots clés et plus la suggestion d’url sera efficace. Tapez au moins 3 mots clés pour faire apparaitre l’outil de suggestion de mot-clés.
			</vs-alert>
        <vs-divider />
		<div class="flex justify-between items-center" >
				<strong class="flex justify-between items-center">
					<vs-chip :color="chipState">{{ totalKeywordsSelected.length }}/{{ keywordLimit }} </vs-chip> 
					&nbsp;  mots-clés sélectionnées
				</strong>
			
		</div>
        <div class="vx-row mt-4">
			
          <vs-chip @click="remove(index)" :key="index" v-for="(keyword,index) of keywordChipsFull" closable>{{ keyword.keyword }}</vs-chip>
          <vs-chip @click="removeByFromTable(index)" closable :key="index" v-for="(keyword,index) of selectedKeywordsFromTable">{{ keyword.keyword }}</vs-chip>
		  <vs-chip @click="removeByAi(index)" closable :key="index" v-for="(keyword,index) of selectedKeywordsFromAi">{{ keyword.keyword }}</vs-chip>
          <!-- <vs-textarea v-model="stringBrands" height="200px" rows="10" /> -->
        </div>

		<vs-button
		v-if = "totalKeywordsSelected.length >= 3"
			class="scale-button animated-scale mt-8"
				icon-pack="feather" icon="icon-zap"
			@click="onClickKeywordSuggestion"
		>
			Lancer la suggestion de mots-clés
		</vs-button>
		<div v-if = "isSuggestedKeywordsLoading" class="mt-5">
			<circular-loader></circular-loader>
		</div>
		<div v-else>
		<vs-table
		v-if="showSuggestedKeywordsTable"
			:data="suggestedKeywords"
			multiple
			v-model="selectedKeywordsFromTable"
			pagination
			search
			max-items="100"
			class="mt-5"
			noDataText="Aucun(e) mots-clés."
		>		<template slot="header">Suggestion de mots-clés par IA</template>
			<template slot="thead">
	<vs-th style="pointer-events: auto" sort-key="keyword">Mots-clés</vs-th>
	<vs-th style="pointer-events: auto" sort-key="cpc">Cpc</vs-th>
	<vs-th style="pointer-events: auto" sort-key="search_volume"
		>Search Volume</vs-th
	>
</template>
			<template slot-scope="{ data }">
	<vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data">
		<vs-td :data="data[indextr].keyword">{{ tr.keyword }}</vs-td>
		<vs-td :data="data[indextr].cpc">{{
			!isNaN(tr.cpc)
				? convertInternationalNumberToFrenchCurrency(tr.cpc)
				: tr.cpc
		}}</vs-td>
		<vs-td :data="data[indextr].search_volume">{{
			tr.search_volume.toLocaleString("fr-FR")
		}}</vs-td>
	</vs-tr>
</template>
		</vs-table>
	</div>
      </div>
      </div>
	  <!-- Open Ai suggestion -->
	  <div class="flex-1 p-4">
		<div class="flex space-x-5">
		<h4>Suggestion de mots-clés par IA</h4>  <div class="tooltip-container">
    <span class="tooltip-icon" @mouseenter="showTooltip" @mouseleave="hideTooltip">
      ℹ️
    </span>
    <div v-if="isTooltipVisible" class="tooltip-content">
      {{ prompt }}
    </div>
  </div>
					</div>
		<br>
		<vs-textarea v-model="promptSuggestion" style="width: 100% ; height=100px" placeholder="Saisissez le contexte en lien avec les de mots clés souhaités. Vous pouvez saisir une localisation, un secteur, un marché, un niveau de gamme… Vous pourrez modifier votre recherche si les résultats ne vous satisfont pas." />
		<div class="flex justify-end mt-4">
    		<vs-button @click="fetchOpenAiSuggestions">Générer</vs-button>
  		</div>
		<div v-if = "isOpenAiSuggestionLoading" class="mt-5">
			<circular-loader></circular-loader>
		</div>

		<div v-else>
			<vs-table
			v-if="openAiKeywordIdeasObj.status_code == 200 && Array.isArray(openAiKeywordIdeasObj.data)"
			:data="openAiKeywordIdeasObj.data"
			multiple
			v-model="selectedKeywordsFromAi"
			pagination
			search
			max-items="100"
			class="mt-20 pt-5"
			noDataText="Aucun(e) mots-clés."
		>
		<template slot="header">Suggestion de mots-clés par IA</template>
			<template slot="thead">
	<vs-th style="pointer-events: auto" sort-key="keyword">Mots-clés</vs-th>
	<vs-th style="pointer-events: auto" sort-key="cpc">Cpc</vs-th>
	<vs-th style="pointer-events: auto" sort-key="search_volume"
		>Search Volume</vs-th
	>
</template>
			<template slot-scope="{ data }">
	<vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data">
		<vs-td :data="data[indextr].keyword">{{ tr.keyword }}</vs-td>
		<vs-td :data="data[indextr].cpc">{{
			tr.cpc && !isNaN(tr.cpc)
				? convertInternationalNumberToFrenchCurrency(tr.cpc)
				: tr.cpc
		}}</vs-td>
		<vs-td :data="data[indextr].search_volume">{{
			tr.search_volume && !isNaN(tr.search_volume)
				? tr.search_volume.toLocaleString("fr-FR")
				: tr.search_volume
		}}</vs-td>
	</vs-tr>
</template>
		</vs-table>
		<vs-textarea
					class="mt-5"
					v-else
					v-model="openAiKeywordIdeasObj.data"
					:placeholder="
						'Les resultats de la suggestion de mots-clés par IA seront affichés ici.'
					"
					readonly
				/>
		</div>
	  </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import store from "@/store/store";
import dbFieldConvertorMixin from "../../../../mixins/dbFieldConvertorMixin";
import ProspectSearch from "../../../../entities/ProspectSearch";
import CircularLoader from "../../../widgets/loader/CircularLoader.vue";

export default {
	name: "TopKeywordEditor",
	props: {
		/*
		 * society: Object,
		 * popupActive: Boolean,
		 */

		topKeywordFromSuggestion: {
			type: Array,
			default: [],
		},
		topKeywords: {
			type: Array,
			default: [],
		},
	},
	components: {
		CircularLoader,
	},
	mixins: [dbFieldConvertorMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			stringTopkeywords: null,
			keywordCounter: 0,
			keywordLimit: 10,
			errorLimit: false,
			keywordChipsFull: [],
			keywordChips: [],
			keywordQuery: "",
			newKeyword: "",
			chipState: "",
			suggestedKeywords: [],
			isSuggestedKeywordsLoading: false,
			showSuggestedKeywordsTable: false,
			selectedKeywordsFromTable: [],
			selectedKeywordsFiltered: [],
			// Suggestion Keywords
			keywordsForAiSuggestion: [],
			selectedKeywordsFromAi: [],
			promptSuggestion: "",
			openAiKeywordIdeasObj: {},
			isOpenAiSuggestionLoading: false,
			prompt: "",

			isTooltipVisible: false,
			tooltipText: "Suggestion de mots-clés par IA",
		};
	},
	updated() {
		console.log("TopKeywordEditor updated");
	},
	created() {
		console.log("TopKeywordEditor created");
		this.fetchPrompts();
		this.keywordCounter = this.$props.topKeywords.length;
		this.keywordChips = this.$props.topKeywords.concat(
			this.$props.topKeywordFromSuggestion
		);
		this.keywordChipsFull = this.keywordChips;
	},
	computed: {
		// Your component's computed properties go here
		newProspects() {
			return store.state.newProspects;
		},
		totalSuggestedKeywordsByOthers() {
			return this.selectedKeywordsFromTable.concat(this.selectedKeywordsFromAi);
		},
		totalKeywordsSelected() {
			return this.keywordChipsFull.concat(this.totalSuggestedKeywordsByOthers);
		},
	},
	watch: {
		keywordChipsFull: function (data) {
			//checking if the keyword limit is reached
			this.keywordChips = data;
			// this.$emit("updated-top-keywords", [
			// 	...this.keywordChipsFull,
			// 	...this.totalSuggestedKeywordsByOthers,
			// ]);
		},

		selectedKeywordsFromTable: function (data) {
			this.selectedKeywordsFiltered = data.map((keyword) => {
				return { keyword: keyword.keyword }; // Returns an object with the `keyword` property
			});
			// this.$emit("updated-top-keywords", [
			// 	...this.keywordChipsFull,
			// 	...this.totalSuggestedKeywordsByOthers,
			// ]);
		},
		totalKeywordsSelected: function (data) {
			if (data.length > this.keywordLimit) {
				this.chipState = "danger";
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Vous avez atteint la limite de mots-clés",
				});
			} else {
				this.chipState = "";
				this.$emit("updated-top-keywords", this.totalKeywordsSelected);
			}
		},
	},
	methods: {
		showTooltip() {
			this.isTooltipVisible = true;
		},
		hideTooltip() {
			this.isTooltipVisible = false;
		},
		async fetchPrompts() {
			try {
				const response = await ProspectSearch.getPrompts();
				this.prompt = response.prompt_1;
			} catch (e) {
				console.log("Error", e);
				this.$vs.notify({
					title: "Echec",
					color: "warning",
					text: "Erreur lors de la récupération des prompts de mots-clés du IA",
				});
			}
		},
		async fetchOpenAiSuggestions() {
			try {
				this.isOpenAiSuggestionLoading = true;
				const body = {
					promptSuggestion: this.promptSuggestion,
					language_name: this.newProspects.language_name,
					location_code: this.newProspects.location_code,
				};
				const response = await ProspectSearch.getOpenAiKeywordsIdeas(body);
				this.openAiKeywordIdeasObj = response;
			} catch (e) {
				console.log("Error", e);
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Erreur lors de la récupération des suggestions de mots-clés par IA",
				});
			} finally {
				this.isOpenAiSuggestionLoading = false;
			}
		},
		async onClickKeywordSuggestion() {
			try {
				this.isSuggestedKeywordsLoading = true;
				const simpleKeywords = this.totalKeywordsSelected.map(
					(keyword) => keyword.keyword
				);
				const reqBody = {
					keywords: simpleKeywords,
					language_name: this.newProspects.language_name,
					location_code: this.newProspects.location_code,
				};
				let response = await ProspectSearch.getKeywordsIdeas(reqBody);
				this.suggestedKeywords = response;

				this.showSuggestedKeywordsTable = true;
			} catch (e) {
				console.log("Error", e);
			}
			this.isSuggestedKeywordsLoading = false;
		},

		validateAllFields() {
			console.log("Running TopEditorKeywords validateAllField");
			let pass = true;
			// Name
			if (this.totalKeywordsSelected.length == 0) {
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Veuillez ajouter des mots clés",
				});
				pass = false;
			}
			return pass;
		},
		addKeyword() {
			if (
				this.keywordChipsFull.filter(
					(element) =>
						element.keyword.toLowerCase() === this.newKeyword.toLowerCase()
				).length > 0
			) {
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Duplicate Mot-clé!",
				});
			} else {
				this.keywordChipsFull.push({ keyword: this.newKeyword.toLowerCase() });
				this.newKeyword = "";
			}
		},
		addKeywords(keywords) {
			for (let keyword of keywords) {
				if (this.keywordChipsFull.includes(keyword.toLowerCase()) == false) {
					this.keywordChipsFull.push({ keyword: keyword.toLowerCase() });
				}
			}
		},
		csvImport() {
			let inputFile = document.getElementById("fileinputtkeyword");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, topKeywords) {
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addKeywords;
			reader.onload = function (e) {
				let mergedKeywords = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });

				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_topKeywords = XLSX.utils.sheet_to_json(
					workbook.Sheets[sheet_name_list[0]],
					{ raw: true, defval: null }
				);
				if (fetched_topKeywords.length > 0) {
					mergedKeywords = [...topKeywords];
					// //console.log("mergedKeywords", mergedKeywords)
					fetched_topKeywords.forEach((row) => {
						if (row.top_keyword && row.top_keyword !== null) {
							if (!mergedKeywords.includes(row.top_keyword))
								mergedKeywords.push(row.top_keyword);
							// //console.log("mergedKeywords updated", mergedKeywords)
						}
					});
					//console.log(mergedKeywords);
					// let stringMergedKeywords = mergedKeywords.join(',')
					callback(mergedKeywords);
				}
			};
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedKeywords updated 2", this.mergedKeywords) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedKeywords)
			 */
		},

		remove(index) {
			this.keywordChipsFull.splice(index, 1);
			this.$emit("updated-top-keywords", this.keywordChipsFull);
		},
		removeByFromTable(index) {
			this.selectedKeywordsFromTable.splice(index, 1);
			this.$emit("updated-top-keywords", this.selectedKeywordsFromTable);
		},
		removeByAi(index) {
			this.selectedKeywordsFromAi.splice(index, 1);
			this.$emit("updated-top-keywords", this.selectedKeywordsFromAi);
		},
		closePopup() {
			this.keywordChipsFull = this.$props.topKeywords;
			this.$emit("close-popup", false);
		},
	},
};
</script>
<style>
.vs-textarea {
	width: 100%;
	height: 110px;
}
.scale-button {
	transition: transform 0.3s ease; /* Smooth transition for hover */
}

/* Continuous scaling animation */
@keyframes scaleAnimation {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.05); /* Scale up slightly */
	}
	100% {
		transform: scale(1); /* Return to original size */
	}
}

.animated-scale {
	animation: scaleAnimation 1.5s infinite; /* Apply animation continuously */
}
/* Toolt tip */
.tooltip-container {
	position: relative;
	display: inline-block;
	cursor: pointer;
}

.tooltip-icon {
	font-size: 16px;
}
.tooltip-content {
	position: absolute;
	top: 120%; /* Places tooltip at the bottom */
	width: 600px; /* Fixed width */
	left: 50%;
	transform: translateX(-50%);
	background-color: rgba(51, 51, 51, 1); /* Fully opaque background */
	color: #fff;
	padding: 8px 12px;
	border-radius: 5px;
	font-size: 14px;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s ease-in-out;
	z-index: 999;
	/* Text wrapping */
	white-space: normal;
	word-wrap: break-word;
	overflow-wrap: break-word;

	/* Optional: Add a more pronounced shadow */
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.5);
}

.tooltip-container:hover .tooltip-content {
	opacity: 1;
	visibility: visible;
}
</style>
